<template>
  <span>
    <v-checkbox
      :disabled="disabled"
      :data-cy="`${attributeName}-checkbox`"
      :false-value="false"
      :label="helpText"
      :rules="ruleList"
      :true-value="true"
      type="boolean"
      v-model="value"
    ></v-checkbox>
  </span>
</template>

<script>
import formElementMixin from "./formElementMixin";
export default {
  mixins: [formElementMixin],
  props: {
    optionConfig: {},
  },
  watch: {
    optionConfig: {
      handler(val) {
        if (!val || this.mode !== "create") {
          return;
        }
        if (!!val && val.defaultValue === true) {
          this.value = true;
        } else {
          this.value = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
